import { createContext, useContext, useEffect, useState } from "react";
import portalApi, { portalLogoUrl } from "./portalApi";

const BrandingContext = createContext({ branding: null, loading: true });

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await portalApi.get("/portal/branding");
        setBranding(data);
        // Inject CSS variables for live theming
        if (data?.primary_color) {
          document.documentElement.style.setProperty("--portal-primary", data.primary_color);
        }
        if (data?.accent_color) {
          document.documentElement.style.setProperty("--portal-accent", data.accent_color);
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <BrandingContext.Provider value={{ branding, loading, logoUrl: portalLogoUrl() }}>
      {children}
    </BrandingContext.Provider>
  );
}

export const useBranding = () => useContext(BrandingContext);
